import { EmailOutlined } from "@mui/icons-material";
import EditFormControl from "components/form/EditFormControl";
import CustomText from "components/typography/CustomText";
import PaymentCardForm from "./PaymentCardForm";

export default function PaymentDetailForm({
  data = {},
  onChange = () => {},
  onPrevious = () => {},
  onNext = () => {},
}) {
  return (
    <div className="bg-secondary px-14 pt-24 pb-14 w-voucher-box rounded-3xl">
      <CustomText className="font-zing text-white text-3xl">
        Email Voucher To:
      </CustomText>
      <div className="py-3">
        <EditFormControl
          type="email"
          name="email"
          placeholder="Email Address"
          startIcon={<EmailOutlined fontSize="large" color="secondary" />}
          value={data?.email ?? ""}
          onChange={onChange}
          fullWidth
        />
      </div>
      <CustomText className="font-zing text-white text-3xl pt-6">
        PAYMENT DETAILS:
      </CustomText>
      <PaymentCardForm data={data} onChange={onChange} onNext={onNext} />
      <CustomText
        className="text-white text-[13px] pt-6 underline cursor-pointer"
        onClick={onPrevious}
      >
        Back to Previous Page
      </CustomText>
    </div>
  );
}
